import React, { useState, useEffect } from "react";
import { Modal, Tabs, Row, Col, Tooltip } from "antd";
import "./TwoDImages.scss";
import ImageCarousel from "./ImageCarousel";
import { CloseOutlined } from "@ant-design/icons";

const { TabPane } = Tabs;

let isAiCustomer = localStorage.getItem('is_ai_customer') === 'true';

const tabsKeyTitleMapping = {
  'all': 'All',
  'favourites': 'Favorites',
  'silo': 'Silo Images',
  'lifestyle': 'Lifestyle Images',
  'ai': '1K Previews',
  'spin_360': '360 Spins',
  'mp4': 'MP4 Video',
  'ai_video': 'Videos',
  'final_images': 'Final Images'
}

const TwoDImagesModal = ({
  updatedRenderNameInImagesList,
  isVisible,
  handleOk,
  handleCancel,
  currentfile,
  filteredImages,
  renderDelete,
  renderDownload,
  renderGenerateHighResImage,
  setType,
  Type,
  imagesCount,
  renderCollaborationTooltip,
  renderReportButton,
  renderFavouriteButton,
  aiPage,
  markFavorite,
  unmarkFavorite,
  handleSubmitForReview
}) => {
  const [activeKey, setActiveKey] = useState(Type || "all");

  // Update local state when Type changes
  useEffect(() => {
    console.log("Type in td:", Type);
    setActiveKey(Type || "all");
  }, [Type]);


  return (
    <div>
      {isVisible && <div className='ai-image-viewer-modal-close-btn pdp-carousel'>
            <Tooltip title={<span className="manrope f-12 white">Close</span>}>
                <CloseOutlined className='manrope f-24 w-500 white' onClick={handleCancel}/>
            </Tooltip>
        </div>}
    <Modal
      className="scene-render-lifestyleimage-viewer-modal-twod-images"
      visible={isVisible}
      closable={false}
      onOk={handleOk}
      onCancel={handleCancel}
      destroyOnClose={true}
      footer={null}
    >
      <Row>
        <Col span={24}>
        <Tabs
            className="items-table"
            tabBarGutter={32}
            activeKey={activeKey}
            size="large"
          >
              <TabPane
                tab={
                  <span className={`manrope f-14 asset-tab-heading`}>
                    {tabsKeyTitleMapping[Type]} ({aiPage ? filteredImages.length : imagesCount[Type]})
                  </span>
                }
                key={activeKey}
                className={`${isAiCustomer ? "" : "pd-0"}`}
              >
                <ImageCarousel
                updatedRenderNameInImagesList={updatedRenderNameInImagesList}
                  currentfile={currentfile}
                  filteredImages={filteredImages}
                  renderDelete={renderDelete}
                  renderDownload={renderDownload}
                  renderGenerateHighResImage={renderGenerateHighResImage}
                  renderCollaborationTooltip={renderCollaborationTooltip}
                  renderReportButton={renderReportButton}
                  renderFavouriteButton={renderFavouriteButton}
                  aiPage={aiPage}
                  markFavorite={markFavorite}
                  unmarkFavorite={unmarkFavorite}
                  handleSubmitForReview={handleSubmitForReview}
                />
              </TabPane>
          </Tabs>
         
        </Col>
      </Row>
    </Modal>
    </div>
  );
};

export default TwoDImagesModal;
